import {
  GET_GLOBAL_IAAC,
  GET_GLOBAL_IAAC_SUCCESSFUL,
  GET_GLOBAL_IAAC_FAILURE,
  PUT_GLOBAL_IAAC,
  PUT_GLOBAL_IAAC_SUCCESSFUL,
  PUT_GLOBAL_IAAC_FAILURE,
  CLEAR_ALL_GLOBAL_IAAC_MESSAGES_SUCCESSFUL
} from "./actionTypes";

const initialState = {
  isGettingGlobalIaac: false,
  getGlobalIaacMessage: null,
  getGlobalIaacError: null,

  isUpdatingGlobalIaac: false,
  updateGlobalIaacMessage: null,
  updateGlobalIaacError: null,
};

const globalIaac = ( state= initialState, action) => {
  console.log("globalIaac Reducer, action: ", action);
  switch(action.type){
    case GET_GLOBAL_IAAC:
      state = {
        ...state,
        orgCode: action.payload.orgCode,
        isGettingGlobalIaac: true,
        getGlobalIaacMessage: null,
        getGlobalIaacError: null
      };
      break;
    case GET_GLOBAL_IAAC_SUCCESSFUL:
      state = {
        ...state,
        isGettingGlobalIaac: false,
        iaac: action.payload.iaac,
        getGlobalIaacMessage: "Global Iaac was successfully retrieved"
      };
      break;
    case GET_GLOBAL_IAAC_FAILURE:
      state = {
        ...state,
        isGettingGlobalIaac: false,
        getGlobalIaacError: action.payload.getGlobalIaacError.message
      };
      break;
    case PUT_GLOBAL_IAAC:
      state = {
        ...state,
        isUpdatingGlobalIaac: true,
        iaac: action.payload.iaac,
        updateGlobalIaacMessage: null,
        updateGlobalIaacError: null,
      };
      break;
    case PUT_GLOBAL_IAAC_SUCCESSFUL:
      state = {
        ...state,
        isUpdatingGlobalIaac: false,
        // iaac: action.payload.iaac,
        updateGlobalIaacMessage: "Global Iaac was successfully updated. Response: "+action.payload.updateGlobalIaacMessage
      };
      break;
    case PUT_GLOBAL_IAAC_FAILURE:
      state = {
        ...state,
        isUpdatingGlobalIaac: false,
        updateGlobalIaacError: action.payload.updateGlobalIaacError.message
      };
      break;
    case CLEAR_ALL_GLOBAL_IAAC_MESSAGES_SUCCESSFUL:
      state = {
        ...state,
        getGlobalIaacMessage: null,
        getGlobalIaacError: null,
        updateGlobalIaacMessage: null,
        updateGlobalIaacError: null,
      };
      break;
    default:
      return state;
  }
  return state;
}

export default globalIaac;